<template>
  <div class="tracker_wrapper" v-if="!isLoading">
    <div class="color_wrapper">
      <p>Выберите карточку и узнайте, что лучше делать в том или ином эмоциональном состоянии</p>
      <ul class="color_list">
        <li v-for="(value, key) in colorsMap" :key="key">
          <div class="mood_color_block" :class="[{'active': value === activeColor}, key]"
               @click="() => pickColor(value)"></div>
        </li>
      </ul>
    </div>

    <div class="cards-container">






      <!-- Окно для записи -->
      <transition name="fade">
        <div class="task_wrapper" @click="() => {activeColor = null; moodForm.task = null}">
        <div class="task_content" @click.stop>
          <button class="popup-close" @click="() => {activeColor = null; moodForm.task = null}">×</button>

          <div class="resume_block">
            <p>
              {{ activeBlock.current }}
            </p>
          </div>
          <div class="tasks_wrapper" v-if="activeColor">

            <p class="header_green">Какую задачу вам сейчас предстоит выполнить?</p>
            <div class="select_wrapper">
              <multiselect
                  :disabled="isButtonDisabled"
                  :options="taskOptions"
                  v-model="moodForm.task"
                  :allow-empty="false"
                  track-by="id" label="text"
                  aria-label="Выберите задачу"
                  placeholder="Выберите задачу"
                  selectedLabel="Выбрано"
                  deselectLabel=""
                  selectLabel=""
                  noResult="Список пуст"
                  noOptions="Нет вариантов"
                  name="trigger_list"
              >
                <template #noOptions>
                  Список пуст
                </template>
              </multiselect>
            </div>
          </div>
          <div v-if="moodForm.task && appropriateMood" class='assessed_mood_wrapper'>
            <div>
              Вы в подходящем состоянии для этой задачи. Используйте его эффективно. Записать, чтобы подвести итог и
              зафиксировать результат?
            </div>
            <div class="button_wrapper">
              <custom-radio v-model="recordInterval" id="record_task_yes" label="Да" name="record_task" value="1"/>
              <custom-radio v-model="recordInterval" id="record_task_no" label="Нет" name="record_task" value="0"/>
            </div>
          </div>

          <div v-if="moodForm.task && !appropriateMood" class='assessed_mood_wrapper'>
            <p>
              Ваше текущее эмоциональное состояние не способствует эффективному решению этой задачи
            </p>
            <p v-for="(item, key) in mismatchText" :key="key">{{ item }}</p>

            <div class="recommendation_wrapper">
              <div class="mood_recommendation">
                <p>Если есть возможность, то рекомендуется сменить задачу на...</p>
                <div class="select_wrapper">
                  <multiselect
                      :disabled="isButtonDisabled"
                      :options="appropriateTasks"
                      v-model="taskReplace"
                      :allow-empty="false"
                      track-by="id" label="text"
                      aria-label="Выберите задачу"
                      placeholder="Выберите задачу"
                      selectedLabel="Выбрано"
                      deselectLabel=""
                      selectLabel=""
                      name="filtered_tasks"
                  >
                    <template #noOptions>
                      Список загружается...
                    </template>
                  </multiselect>
                </div>
                <button class="btn btn-accent" @click="() => moodForm.task = taskReplace">Сменить задачу</button>
              </div>
              <div class="mood_recommendation">
                <p>
                  {{ mismatchRecommendation }}
                </p>
                <button class="btn btn-accent">Узнать как</button>
              </div>
            </div>
          </div>

          <div v-if="parseInt(recordInterval) && appropriateMood" class="tasks_wrapper">
            <p>Выберите время, когда удобно отметить результат выполнения задачи</p>
            <div class="select_wrapper">
              <multiselect
                  :disabled="isButtonDisabled"
                  :options="intervals"
                  v-model="moodForm.feedback_interval"
                  :allow-empty="false"
                  aria-label="Выберите интервал"
                  placeholder="Выберите интервал"
                  selectedLabel="Выбрано"
                  deselectLabel=""
                  selectLabel=""
                  name="feedback_intervals"
              >
                <template #noOptions>
                  Список загружается...
                </template>
              </multiselect>
            </div>
          </div>
          <div class="save_button_wrapper" v-if="appropriateMood">
            <button class="btn btn-accent" @click="() => saveRecord()" :disabled="isButtonDisabled">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      </transition>

    </div>
  </div>
  <div v-else class="loader">
    <mini-preloader/>
  </div>
</template>

<script>
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
import {useStore} from "vuex";
import {onBeforeMount, ref, watch} from "@vue/runtime-core";
import {computed, reactive} from "@vue/reactivity";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import textCard from "./colorCardText";
import {Multiselect} from 'vue-multiselect'
import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
import app from "@/App.vue";
import {notify} from "@kyvg/vue3-notification";

export default {
  name: "MoodTrackerForm",
  computed: {
    app() {
      return app
    }
  },
  components: {CustomTextarea, Multiselect, CustomRadio, CustomInput, MiniPreloader, CustomSelect2},
  setup() {
    const store = useStore();

    const colorList = computed(() => store.state.tracker.colorList);
    const taskList = computed(() => store.state.tracker.taskList);

    const isLoading = ref(false);
    const isSaved = ref(false);
    const isCompleted = ref(false);
    const activeColor = ref('');
    const recommendedColor = ref('');
    const taskOptions = ref([]);
    const appropriateMood = ref();
    const isButtonDisabled = ref(false);
    const activeBlock = ref();
    const recordInterval = ref();
    const mismatchText = ref();
    const mismatchRecommendation = ref();
    const appropriateTasks = ref([]);
    const taskReplace = ref();
    const moodAssessorOpen = ref(false);
    const suggestionText = ref();
    const moodAssessmentQuestions = ref([]);
    const lastSuggestedColor = ref();
    const moodAssessed = ref();

    const moodForm = reactive({
      color_id: null,
      task_id: null,
      task: null,
      feedback_interval: null,
    });

    const colorsMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    };

    const moodAssessmentForm = reactive({
      index: 0,
      red: 0,
      yellow: 0,
      blue: 0,
      green: 0,
      current: null,
    });

    const reassessMood = () => {
      moodAssessmentForm.index++;
      shiftAssessmentQuestions();
      lastSuggestedColor.value = null;
      suggestionText.value = null;
      moodAssessmentForm.current = null;
    }

    const resetAssessmentTool = () => {
      moodAssessorOpen.value = false;
      moodAssessmentForm.index = 0;
      moodAssessmentForm.red = 0;
      moodAssessmentForm.yellow = 0;
      moodAssessmentForm.blue = 0;
      moodAssessmentForm.green = 0;
      moodAssessmentForm.current = null;
      moodAssessed.value = false;
      suggestionText.value = false;
      lastSuggestedColor.value = false;
    }

    const setColor = () => {
      moodAssessorOpen.value = false;
      pickColor(colorsMap[moodAssessmentForm.current.color]);
      resetAssessmentTool();
    }

    const shiftAssessmentQuestions = () => {
      let tempArray = [];
      Object.keys(colorsMap).forEach((key) => {
        tempArray.push({
          color: key,
          text: textCard[key].assessment[moodAssessmentForm.index]
        });
      })
      moodAssessmentQuestions.value = tempArray;
    }

    const pickColor = (value) => {
      const color = colorList.value.find((el) => el.name === value);
      moodForm.color_id = color.id;
      const currentColorKey = Object.keys(colorsMap).find(key => colorsMap[key] === value);

      activeBlock.value = colorBlocks.value.find((el) => el.block === currentColorKey);
      activeBlock.value.current = getRandomBlockText(textCard[currentColorKey].resume);
      closePopup();

      activeColor.value = value;

      // закрыть все карточки
      colorBlocks.value.map((block) => {
        block.open = false;
      });

      setTimeout(() => {
        let popup = document.querySelector('.task_content');
        popup.scrollIntoView({behavior: "smooth", block: "center"});
      }, 100)
    }

    const getRecommendation = () => {
      let taskColor = taskList.value.find((el) => el.id === parseInt(moodForm.task.id));
      let bestForTaskColor = colorList.value.find((el) => el.id === parseInt(taskColor.color_id));
      let recommendedColorKey = Object.keys(colorsMap).find(key => colorsMap[key] === bestForTaskColor.name);

      appropriateMood.value = moodForm.color_id === taskColor.color_id;
      recommendedColor.value = bestForTaskColor.name;

      mismatchText.value = textCard[activeBlock.value.block].mismatch[recommendedColorKey];
      mismatchRecommendation.value = textCard[recommendedColorKey].mismatch_recommendation;
      appropriateTasks.value = taskList.value.filter((task) => task.color_id === parseInt(moodForm.color_id)).map((el) => {
        return {id: el.id, text: el.task};
      });
    }

    const reset = () => {
      moodForm.task_id = null;
      moodForm.task = null;
      moodForm.color_id = null;
      activeColor.value = null;
      isCompleted.value = false;
      isSaved.value = false;
      activeBlock.value = null;
      activeColor.value = null;
    }

    const openAssessmentTool = () => {
      closePopup();
      shiftAssessmentQuestions();
      moodAssessorOpen.value = true;

      setTimeout(() => {
        let popup = document.querySelector('.question_content');
        popup.scrollIntoView({behavior: "smooth", block: "center"});
      }, 100)

    }

    const getColorByName = (name) => {
      return Object.keys(colorsMap).find(key => colorsMap[key] === name);
    }

    const saveRecord = () => {
      if (parseInt(recordInterval.value) && !moodForm.feedback_interval) {
        notify({
          title: "Укажите интервал",
          text: "Выберите интервал для записи",
          type: "warning"
        });

        return;
      } else if (!parseInt(recordInterval.value)) {
        moodForm.feedback_interval = null;
      }

      isButtonDisabled.value = true;
      moodForm.task_id = moodForm.task.id;

      store.dispatch('tracker/createRecord', moodForm).then(() => {
        isSaved.value = true;
        isButtonDisabled.value = false;
        activeColor.value = null;
        reset();
      }).catch(() => {
        isButtonDisabled.value = false;
      });
    }

    const colorBlocks = ref([
      {
        id: 1,
        image: require('@/assets/images/mood_tracker/red.svg'),
        title: 'Высокая энергия / неприятные ощущения',
        color: '#9c0130',
        open: false,
        block: 'red',
        block_type_translate: 'в красном квадрате',
        text: null,
        detailed: textCard.red.detailed,
        current: '',
      },
      {
        id: 2,
        image: require('@/assets/images/mood_tracker/yellow.svg'),
        title: 'Высокая энергия / приятные ощущения',
        color: '#ff9e02',
        open: false,
        block: 'yellow',
        text: null,
        block_type_translate: 'в желтом квадрате',
        detailed: textCard.yellow.detailed,
        current: '',
      },
      {
        id: 3,
        image: require('@/assets/images/mood_tracker/blue.svg'),
        title: 'Низкая энергия / неприятные ощущения',
        block_type_translate: 'в синем квадрате',
        color: '#100f76',
        open: false,
        block: 'blue',
        text: null,
        detailed: textCard.blue.detailed,
        current: '',
      },
      {
        id: 4,
        image: require('@/assets/images/mood_tracker/green.svg'),
        title: 'Низкая энергия / приятные ощущения',
        block_type_translate: 'в зеленом квадрате',
        color: '#3d9123',
        open: false,
        block: 'green',
        text: null,
        detailed: textCard.green.detailed,
        current: '',
      }
    ]);

    const toggleCard = (index) => {
      const item = colorBlocks.value[index];
      item.open = !item.open

      // закрыть остальные
      colorBlocks.value.map((block) => {
        if (block !== item) {
          block.open = false;
        }
      });

      item.text = getRandomBlockText(textCard[item.block].description);
    }

    const getRandomBlockText = (block) => {
      if (!block.length) return null
      const randomIndex = Math.floor(Math.random() * block.length)
      return block[randomIndex];
    }

    const selectedBlock = ref(null);

    const openPopup = (block) => {
      selectedBlock.value = block;

      setTimeout(() => {
        let popup = document.querySelector('.popup-content');
        popup.scrollIntoView({behavior: "smooth", block: "center"});
      }, 100);
    }
    const closePopup = () => {
      selectedBlock.value = null;
    }

    onBeforeMount(() => {
      isLoading.value = true;

      store.dispatch('tracker/getTasks').then(() => {
        taskOptions.value = taskList.value.map((el) => {
          return {id: el.id, text: el.task};
        });
      });
      store.dispatch('tracker/getColors').then(() => {
        isLoading.value = false;
      });
    });

    watch(() => moodForm.task, () => {
      recordInterval.value = null;
      moodForm.feedback_interval = null;
      taskReplace.value = null;

      if (moodForm.task) {
        getRecommendation();
      }
    });

    const intervals = [
      '00:00-00:30', '00:30-01:00', '01:00-01:30', '01:30-02:00', '02:00-02:30', '02:30-03:00',
      '03:00-03:30', '03:30-04:00', '04:00-04:30', '04:30-05:00', '05:00-05:30', '05:30-06:00',
      '06:00-06:30', '06:30-07:00', '07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00',
      '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00',
      '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00',
      '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00',
      '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00',
      '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00', '23:00-23:30', '23:30-24:00'
    ];

    return {
      moodForm,
      taskOptions,
      colorList,
      colorsMap,
      activeColor,
      pickColor,
      isLoading,
      isCompleted,
      getRecommendation,
      recommendedColor,
      getColorByName,
      reset,
      saveRecord,
      isSaved,
      appropriateMood,
      isButtonDisabled,
      colorBlocks,
      toggleCard,
      getRandomBlockText,
      selectedBlock,
      openPopup,
      closePopup,
      activeBlock,
      intervals,
      recordInterval,
      mismatchText,
      mismatchRecommendation,
      appropriateTasks,
      taskReplace,
      moodAssessorOpen,
      moodAssessmentForm,
      moodAssessmentQuestions,
      shiftAssessmentQuestions,
      openAssessmentTool,
      resetAssessmentTool,
      suggestionText,
      lastSuggestedColor,
      moodAssessed,
      reassessMood,
      setColor
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">

.tracker_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  padding: 50px 20px;
}

.mood_color_block {
  width: 60px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.mood_color_block:hover {
  opacity: 0.9;
}

.color_list {
  margin: 20px 0;
  display: flex;
  width: 100%;
  column-gap: 25px;
  justify-content: right;
}

.question_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.question {
  font-size: 18px;
}

.answers {
  display: flex;
  column-gap: 25px;
}

.tasks_wrapper .form-group {
  justify-content: flex-start;
}

.loader {
  padding: 120px 0;
  text-align: center;
}

.mood_color_block.yellow {
  background-image: linear-gradient(rgba(255, 236, 138, 0.6), rgba(255, 236, 138, 0.6)), url("../../assets/images/yellow-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #ffec8a;
}

.mood_color_block.green {
  background-image: linear-gradient(rgba(176, 220, 156, 0.6), rgba(176, 220, 156, 0.6)), url("../../assets/images/green-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #b0dc9c;
}

.mood_color_block.blue {
  background-image: linear-gradient(rgba(130, 152, 204, 0.6), rgba(130, 152, 204, 0.6)), url("../../assets/images/blue-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #8298cc;
}

.mood_color_block.red {
  background-image: linear-gradient(rgba(242, 145, 117, 0.6), rgba(242, 145, 117, 0.6)), url("../../assets/images/red-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #f29175;
}

.color_text {
  font-weight: bold;
}

.text_yellow {
  color: #ffec8a;
}

.text_green {
  color: #b0dc9c;
}

.text_blue {
  color: #8298cc;
}

.text_red {
  color: #f29175;
}

.active::after {
  content: "✓";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  color: #00e287;
  pointer-events: none;
}

.red.active {
  background-image: url("../../assets/images/mood_tracker/red.svg");
}

.green.active {
  background-image: url("../../assets/images/mood_tracker/green.svg");
}

.blue.active {
  background-image: url("../../assets/images/mood_tracker/blue.svg");
}

.yellow.active {
  background-image: url("../../assets/images/mood_tracker/yellow.svg");
}

.repeat_button_wrapper {
  display: flex;
  column-gap: 10px;
  margin-left: auto;
}

.recommendation_wrapper {
  margin-top: 15px;
  font-size: 18px;
  text-align: justify;
}

.square_recommendation_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

@media (max-width: 400px) {
  .color_list {
    flex-direction: column;
    row-gap: 10px;
  }

  .mood_color_block {
    width: 100%;
  }
}

.close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  z-index: 2;
}

.close-btn:hover {
  color: #000;
}

.popup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.popup-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 40px;
  padding: 20px;
  max-width: 800px;
  min-height: 800px;
  width: 90%;
  position: relative;
  color: #fff;
  border: 5px solid #cccccc;
}

.popup-content ul {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}

.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.popup_additional_wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 25px;
}

.popup_additional_wrapper p {
  font-size: 22px;
  color: #ffffff;
  font-weight: bold;
}

.popup_button_wrapper, .button_wrapper {
  display: flex;
  column-gap: 25px;
}

.popup_button_wrapper button,
.button_wrapper button {
  padding: 10px 20px;
  background-color: #edf2f8;
}

.popup_button_wrapper button:hover,
.button_wrapper button:hover {
  opacity: 0.8;
}

.task_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.task_content {
  width: 80%;
  padding: 40px 0;
  position: relative;
  background-color: #ffffff;
  border: 4px solid;
}

.resume_block {
  margin: 0 20px 30px;
  padding: 50px 0;
  position: relative;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.additional_block_wrapper {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
}

.additional_block_wrapper:first-child {
  top: 0;
}

.additional_block_wrapper {
  bottom: 0;
}

.colorful_block {
  width: 30px;
  height: 30px;
}

.yellow {
  background-color: #ff9e02;
}

.blue {
  background-color: #100f76;
}

.green {
  background-color: #3d9123;
}

.red {
  background-color: #9c0130;
}

.tasks_wrapper {
  padding: 30px 20px;
  background-color: #edf2f8;
}

.header_green {
  font-size: 18px;
  font-weight: bold;
  color: #51bb50;
}

.select_wrapper {
  margin: 20px 0;
  width: 80%
}

.assessed_mood_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 20px;
}

.save_button_wrapper {
  display: flex;
  justify-content: end;
  padding: 10px 20px;
}

.recommendation_wrapper {
  display: flex;
  column-gap: 15px;
  justify-content: space-between;
  align-items: center;
}

.mood_recommendation {
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 20px;
  width: 48%;
  min-height: 350px;
  font-size: 16px;
  background-color: #edf2f8;
}

.mood_recommendation button {
  margin-top: auto;
}

.mood_recommendation .select_wrapper {
  width: 100%;
}

.question_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.question_content {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 80%;
  padding: 40px 20px;
  position: relative;
  background-color: #ffffff;
  border: 2px solid #000;
}

.suggestion_wrapper p {
  font-size: 18px;
  font-weight: bold;
}

.suggestion_wrapper .button_wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  column-gap: 20px;
}

:deep(.multiselect__option) {
  padding: 10px 5px;
  white-space: normal;
}

@media (max-width: 700px) {
  .recommendation_wrapper {
    flex-direction: column;
    row-gap: 20px;
  }
}

@media (max-width: 1480px) {
  .card {
    width: 350px;
    height: 500px;
  }
}

@media (max-width: 1275px) {
  .card {
    width: 250px;
    height: 400px;
    font-size: 12px;
  }
}

@media (max-width: 1050px) {
  .cards-container {
    grid-template-columns: 1fr;
  }

  .task_content {
    width: 100%;
  }

  .mood_recommendation {
    width: 100%;
  }
}

@media (max-width: 550px) {
  .card {
    width: 220px;
    height: 420px;
    font-size: 12px;
  }

  .popup_button_wrapper {
    row-gap: 20px;
    flex-wrap: wrap;
  }
}

.question_content.base {
  background-color: #ffffff;
}

.question_content.yellow {
  color: #ffffff;
  background-color: #ff9e02;
}

.question_content.blue {
  color: #ffffff;
  background-color: #100f76;
}

.question_content.green {
  color: #ffffff;
  background-color: #3d9123;
}

.question_content.red {
  color: #ffffff;
  background-color: #9c0130;
}

.question_content span.special_green {
  color: #51bb50;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>
